var whatsAppNotifyApiUrl = "https://bha3bcrvprwpobphyyptocb5om0jgoxa.lambda-url.ap-east-1.on.aws/";
if (void 0 === whatsAppSelectClass)
    var whatsAppSelectClass = "#product-select, .selector-wrapper > select,  .single-option-selector, .single-option-selector__radio";
if (void 0 === whatsAppWraperClass)
    var whatsAppWraperClass = "form";
if (void 0 === whatsAppVarSelector)
    var whatsAppVarSelector = "[name=id]";
var whatsAppVariant = {}
  , whatsAppVarIdOld = 0;
function whatsAppGetVariant(c, a) {
    var b = !1;
    return jQuery.each(a, function(d, a) {
        a.id == c && (b = a)
    }),
    b
}
function whatsAppNotifyClick(a, iti) {
    a.addClass("disabled"),
    a.attr("disabled", "disabled");
    var b = a.parents(whatsAppWraperClass);
    b.find(".whatsApp-msg").removeClass("whatsApp-error").hide();
    var c = iti.getNumber();
    console.log("Adding :: " + whatsAppProduct.title + " : " + whatsAppVariant.title + " : " + c + " : " + whatsAppProduct.id + " : " + whatsAppVariant.id),
    c != '' && whatsAppNotifyApiUrl ? 

        jQuery.ajax({
        url: whatsAppNotifyApiUrl,
        method: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
            action: "submit",
            shopId: whatsAppProduct.shopId,
            cust: c,
            vid: whatsAppVariant.id,
            pid: whatsAppProduct.id,
            vTitle: whatsAppVariant.title,
            pTitle: whatsAppProduct.title
        }),
        success: function(a) {
            a && (a.inserted || a.duplicate) && (b.find(".whatsApp-msg").html(whatsAppSuccessMsg).show()),
            "undefined" != typeof whatsAppAddFn && "function" == typeof whatsAppAddFn && whatsAppAddFn()
        },
        error: function() {
            b.find(".whatsApp-msg").html(whatsAppSystemErrorMsg).addClass("whatsApp-error").show()
        }
        }).always(function() {
            a.removeClass("disabled"),
            a.attr("disabled", !1)
            sessionStorage.setItem('whatsAppPhoneId', c)
        })
        
     : (b.find(".whatsApp-msg").html(whatsAppErrorMsg).addClass("whatsApp-error").show(),
    setTimeout(function() {
        a.removeClass("disabled"),
        a.attr("disabled", !1)
    }, 500))
}
function whatsAppUrlParam(b) {
    var a = new RegExp("[?&]" + b + "=([^&#]*)").exec(window.location.href);
    return null != a ? a[1] || 0 : a
}
function whatsAppNotifyShow() {
    var a = parseInt(jQuery("body").find(whatsAppVarSelector).val());
    if (null != a && a != whatsAppVarIdOld) {
        whatsAppVarIdOld = a;
        whatsAppVariant = whatsAppGetVariant(a, whatsAppProduct.variants);

        if (!whatsAppVariant.available && !whatsAppVariant.excluded) {
            jQuery(".whatsApp-notify-btn").removeClass("disabled").attr("disabled", !1)
            jQuery(".whatsApp-wrapper").show()
        }
        else {
            jQuery(".whatsApp-wrapper").hide()
        }
    }
    else {
        whatsAppVarIdOld = 0,
        jQuery(".whatsApp-wrapper").hide()
    }
}
function whatsAppInit() {
    const zhHk = {
        selectedCountryAriaLabel: "更改電話號碼的國家，選擇「${countryName}」（${dialCode}）",
        noCountrySelected: "選擇電話號碼的國家",
        countryListAriaLabel: "國家清單",
        searchPlaceholder: "搜尋",
        clearSearchAriaLabel: "清除搜尋",
        searchEmptyState: "未找到相關項目",
        searchSummaryAria(count) {
            if (count === 0) {
                return "未找到相關項目";
            }
            return `找到 ${count} 個相關項目`;
        }
    }
    const input = document.querySelector("#whatsApp-phone-id");
    const whatsAppPhoneId = sessionStorage.getItem('whatsAppPhoneId');
    if (whatsAppPhoneId != null && input) {
        input.value = whatsAppPhoneId;
    }
    const iti = window.intlTelInput(input, {
        uiTranslations: zhHk,
        countryNameLocale: "zh-hk",
        initialCountry: "hk",
        countryOrder: ["hk","mo","cn","tw"],
        showFlags: false,
        loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@29.1.0/dist/js/utils.js"),
    })
    if (jQuery.fn.on && (jQuery("body").on("click", ".whatsApp-notify-btn", function(a) {
        whatsAppNotifyClick(jQuery(this), iti)
    }),
    jQuery("body").on("change", whatsAppSelectClass, function() {
        jQuery(".whatsApp-wrapper").hide().find(".whatsApp-msg").hide();
        var a = jQuery(this).parents(whatsAppWraperClass);
        setTimeout(function() {
            whatsAppNotifyShow(whatsAppProduct, a)
        }, 300)
    }),
    whatsAppNotifyShow(whatsAppProduct, jQuery(whatsAppSelectClass).parents(whatsAppWraperClass)),
    true))
    true
}
window.addEventListener ? window.addEventListener("load", whatsAppInit, !1) : window.attachEvent ? window.attachEvent("onload", whatsAppInit) : window.onload = whatsAppInit
